module.exports = __webpack_public_path__ + "static/media/overview.55a266aa.svg";